<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" ref="searchForm" label-width="80px">
          <el-form-item label="商品ID" prop="goodsId">
            <el-input v-model="searchForm.goodsId" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="商品规格" prop="spec">
            <el-input v-model.trim="searchForm.spec" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="规格ID" prop="skuId">
            <el-input v-model="searchForm.skuId" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="uploadStatus">
            <el-select v-model="searchForm.uploadStatus" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option label="成功" value="成功"></el-option>
              <el-option label="失败" value="失败"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="pddOfficialInfo">刷新</el-button>
        <el-button type="primary" size="small" @click="importExcel">导入</el-button>
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
      </template>
      <el-table :data="tableData.list" ref="tableRef" border :height="maxTableHeight" @sort-change="handleSortChange" v-loading="loading">
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :fixed="item.fixed"
          :min-width="item.width"
          show-overflow-tooltip
          v-for="item in columnData"
          :key="item.prop"
          :align="item.children ? 'center' : 'left'"
        >
          <template slot-scope="scope">
            {{ scope.row[item.prop] }}
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="between">
          <div style="color: #555555">
            <span>{{ timeText.updateContent ? "数据刷新时间：" : "" }}</span>
            <span>{{ timeText.latestUpdateTime ? timeText.latestUpdateTime : "" }}</span>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.pageNum"
              :page-sizes="[30, 60, 90]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import axios from "@/utils/axiosInstance";
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from "moment";

export default {
  name: "PddBatchModifyPrices",
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      searchForm: {
        goodsId: "",
        spec: "",
        skuId: "",
        uploadStatus: ""
      },
      tableHeight: 0,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      rowData: {},
      loading: false,
      all: false,
      searchFormData: {},
      imgList: [],
      columnData: [],
      orderDto: {},
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      queryCriteria: [],
      dialogType: 1,
      reportName: "pddGoodsPriceInfo",
      timeText: {},
    };
  },
  computed: {},
  mounted() {
    this.columns();
    this.getRefreshTime();
  },
  methods: {
    pddOfficialInfo() {
      this.loading = true
      this.$q.dataImport.pddOfficialInfo().then((res) => {
        this.$message.success(res.message)
        this.onSearch()
      }).finally(_=>{
        this.loading = false
      });
    },
    getRefreshTime() {
      this.$q.common.getRefreshTime({ fragment: ["151"] }).then((res) => {
        this.timeText = res.data;
      });
    },
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns.map((v) => {
          return {
            label: v.displayName,
            prop: v.columnName,
            width: v.displayWidth,
            sortable: v.sortable == "1" ? "custom" : false,
            span: false,
            fixed: v.freezeType,
          };
        });
        this.onSearch();
      });
    },
    onSearch() {
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "goodsId", //商品ID
          val: this.searchForm.goodsId ? this.searchForm.goodsId.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "spec", //商品规格
          val: this.searchForm.spec ? this.searchForm.spec : "",
          op: "like",
        },
        {
          attributeName: "skuId", //规格ID
          val: this.searchForm.skuId ? this.searchForm.skuId.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "uploadStatus", //状态
          val: [this.searchForm.uploadStatus ? this.searchForm.uploadStatus : ''],
          op: "in",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      console.log(val);
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      console.log(val);
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.$refs.searchForm.resetFields();
      this.onSearch();
    },
    handleSortChange({ column, prop, order }) {
      let type = order === "ascending" ? "0" : order === "descending" ? "1" : false;
      this.tableData.pageNum = 1;
      this.orderDto = {
        sortField: prop,
        sortOptions: order === "ascending" ? "0" : order === "descending" ? "1" : "",
      };
      this.orderDto = type ? this.orderDto : {};
      this.init();
    },
    //导入
    importExcel() {
      this.openSubPage({
        path: "/pddBatchModifyPricesImport",
        query: {
          fileName: "拼多多批量修改价格导入.xlsx",
          appCode: "ec-pc-new",
          reportName: "pddGoodsPriceInfoImport",
        },
      });
    },
    //导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: {
            ...this.searchFormData,
          },
          reportName: this.reportName,
        },
        columnDTOs: [],
      };
      params.columnDTOs = this.columnData
        .map((item) => {
          return {
            columnName: item.label,
            fieldName: item.prop,
            fieldType: "string",
            columnFormat: null,
          };
        })
        .filter((v) => v.label != "图片"); // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.label !== "图片");
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
body {
  height: auto !important
}
.between {
  display: flex
  justify-content: space-between
  align-items: center
}
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
